var column0 = 4,        // CREDITS, INFO
    column1 = 194,      // LINES, LINEBET
    column2 = 422,      // WIN, TOTALBET
    column3 = 612,      // BETMAX, BETMIN
    column4 = 750,      // GAMBLE, AUTOPLAY
    column5 = 888,      // START, STOP, COLLECT, FINISH
    row0 = 632,         //
    row1 = 701,         //
    arrow_left_width = 53,      // ширина стрелки влево
    line_bet_button_width = 116, // ширина кнопок изменения линий и ставки
    line_bet_frame_width = 222,  // полная ширина кнопок изменения линий и ставки
    narrow_frame_width = 184,   // ширина всех остальныех информационных рамок
    text_vertical_offset = 32;  // вертикальное смещение текста в рамке (верх текста)


module.exports = {
    common: {
        font:'userinterface-font'
    },
    
    buttons: {
        spin: {
            frames:{
                normal:'start_normal.png',
                pressed:'start_pressed.png',
                disabled:'start_disabled.png',
                hover: 'start_hover.png'
            },
            position:{x:column5, y:row0}
        },
        
        collect: {
            frames:{
                normal:'collect_normal.png',
                pressed:'collect_pressed.png',
                disabled:'collect_disabled.png',
                hover: 'collect_hover.png'
            },
            position:{x:column5, y:row0}
        },
        
        stop: {
            frames:{
                normal:'stop_normal.png',
                pressed:'stop_pressed.png',
                disabled:'stop_disabled.png',
                hover: 'stop_hover.png'
            },
            position:{x:column5, y:row0}
        },
        
        start: {
            frames:{
                normal:'start_normal.png',
                pressed:'start_pressed.png',
                disabled:'start_disabled.png',
                hover: 'start_hover.png'
            },
            position:{x:column5, y:row0}
        },
        
        finish: {
            frames:{
                normal:'finish_normal.png',
                pressed:'finish_pressed.png',
                disabled:'finish_disabled.png',
                hover: 'finish_hover.png'
            },
            position:{x:column5, y:row0}
        },
        
        info: {
            frames:{
                normal:'info_normal.png',
                pressed:'info_pressed.png',
                disabled:'info_disabled.png',
                hover: 'info_hover.png'
            },
            position:{x:column0, y:row1}
        },
        
        gamble: {
            frames:{
                normal:'gamble_normal.png',
                pressed:'gamble_pressed.png',
                disabled:'gamble_disabled.png',
                hover: 'gamble_hover.png'
            },
            position:{x:column4, y:row0}
        },
        
        betmax: {
            frames:{
                normal:'bet_max_normal.png',
                pressed:'bet_max_pressed.png',
                disabled:'bet_max_disabled.png',
                hover: 'bet_max_hover.png'
            },
            position:{x:column3, y:row0}
        },
        
        betmin: {
            frames:{
                normal:'bet_min_normal.png',
                pressed:'bet_min_pressed.png',
                disabled:'bet_min_disabled.png',
                hover: 'bet_min_hover.png'
            },
            position:{x:column3, y:row0}
        },
        
        autoplay: {
            frames:{
                normal:'autoplay_normal.png',
                pressed:'autoplay_pressed.png',
                disabled:'autoplay_disabled.png',
                hover: 'autoplay_hover.png'
            },
            position:{x:column4, y:row0}
        },
        
        autoplayoff: {
            frames:{
                normal:'autoplayoff_normal.png',
                pressed:'autoplayoff_pressed.png',
                disabled:'autoplayoff_disabled.png',
                hover: 'autoplayoff_hover.png'
            },
            position:{x:column4, y:row0}
        },
        
        menu: {
            frames:{
                normal:'menu_normal.png',
                pressed:'menu_pressed.png',
                disabled:'menu_disabled.png',
                hover: 'menu_hover.png'
            },
            position:{x:2, y:2}
        },
        
        decrease_lines: {
            frames:{
                normal:'arrow_left_normal.png',
                pressed:'arrow_left_pressed.png',
                disabled:'arrow_left_disabled.png',
                hover: 'arrow_left_hover.png'
            },
            position:{x:column1, y:row0}
        },
        
        increase_lines: {
            frames:{
                normal:'arrow_right_normal.png',
                pressed:'arrow_right_pressed.png',
                disabled:'arrow_right_disabled.png',
                hover: 'arrow_right_hover.png'
            },
            position:{x:column1 + arrow_left_width + line_bet_button_width, y:row0}
        },
        
        lines: {
            frames:{
                normal:'lines_normal.png',
                pressed:'lines_pressed.png',
                disabled:'lines_disabled.png',
                hover: 'lines_hover.png'
            },
            position:{x:column1 + arrow_left_width, y:row0}
        },
        
        decrease_linebet: {
            frames:{
                normal:'arrow_left_normal.png',
                pressed:'arrow_left_pressed.png',
                disabled:'arrow_left_disabled.png',
                hover: 'arrow_left_hover.png'
            },
            position:{x:column1, y:row1}
        },
        
        increase_linebet: {
            frames:{
                normal:'arrow_right_normal.png',
                pressed:'arrow_right_pressed.png',
                disabled:'arrow_right_disabled.png',
                hover: 'arrow_right_hover.png'
            },
            position:{x:column1 + arrow_left_width + line_bet_button_width, y:row1}
        },
        
        linebet: {
            frames:{
                normal:'line_bet_normal.png',
                pressed:'line_bet_pressed.png',
                disabled:'line_bet_disabled.png',
                hover: 'line_bet_hover.png'
            },
            position:{x:column1 + arrow_left_width, y:row1}
        },
        next: {
            frames: {
                normal:"next_normal.png",
                hover: 'next_hover.png',
                pressed:"next_pressed.png",
                disabled:"next_disabled.png"
            },
            position:{x:795,y:768-100}
            // active_area:{x:14,y:14,w:183,h:121}
        },
        exit: {
            frames: {
                normal:"exit_normal.png",
                hover: 'exit_hover.png',
                pressed:"exit_pressed.png",
                disabled:"exit_disabled.png"
            },
            position:{x:417, y:768-100}
            // active_area:{x:15,y:15,w:118,h:118}
        },
        back: {
            frames: {
                normal:"back_normal.png",
                hover: 'back_hover.png',
                pressed:"back_pressed.png",
                disabled:"back_disabled.png"
            },
            position:{x:17, y:768-100}
            // active_area:{x:12,y:15,w:185,h:119}
        }
    },
    
    frames: {
        lines:{
            frame:'lines_line_bet.png',
            text_position:{x:line_bet_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column1, y:row0}
        },
        
        line_bet:{
            frame:'lines_line_bet.png',
            text_position:{x:line_bet_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5,y:0.5},
            position:{x:column1, y:row1}
        },
        
        win:{
            frame:'win_frame.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column2, y:row0}
        },
        
        credits:{
            frame:'credits.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column0, y:row0}
        },
        
        total_bet:{
            frame:'total_bet.png',
            text_position:{x:narrow_frame_width / 2, y:text_vertical_offset},
            text_align:{x:0.5, y:0.5},
            position:{x:column2, y:row1}
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/userinterface-config.js
// module id = 36
// module chunks = 0